import * as React from 'react';

import './style.scss';
import TabbedContent from '../../../../components/TabbedContent';

const VisionSection = () => {
  const mandateTabs = [
    {
      title: 'Protect consumers',
      content: (
        <>
          <p>
            Our aim is to protect consumers of professional services across Australia by demanding high levels of
            professional standards from those who participate in the national system of professional standards
            regulation.
          </p>

          <p>
            Occupational associations with an approved professional standards scheme and their members have committed to
            ensuring competent and ethical conduct by their members in providing services and ensuring avenues of
            resolution and redress are available to consumers.
          </p>
        </>
      ),
    },
    {
      title: 'Improve professional standards',
      content: (
        <>
          <p>
            Our aim is to encourage and assist associations to improve the professional standards of their members by
            implementing occupational risk management strategies and professional integrity systems.
          </p>
          <p>
            We encourage the development of professional standards and regulatory capacity through research, publishing
            information, providing guidance, and delivering forums. We promote discussion and better regulation in the
            areas of risk management, membership requirements, codes of ethics and practice, resolution of complaints,
            discipline of members, continuing education, insurance standards and quality management.
          </p>
        </>
      ),
    },
    {
      title: 'Help associations',
      content: (
        <>
          <p>
            Our role is to approve and supervise the operation of professional standards schemes. This involves helping
            occupational associations to develop their professional standards and regulatory systems, as well as to
            comply with the professional standards legislation.
          </p>
        </>
      ),
    },
  ];

  return (
    <section className="l-vision">
      <div className="container">
        <h2 className="section-title">Our Vision, Mission, Mandate</h2>

        <div className="grid">
          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <h3 className="card-title">Our Vision</h3>
            <p>
              The Councils are independent statutory bodies with powers to consider and approve applications from
              occupational associations for a professional standards scheme under professional standards legislation.
            </p>
          </div>

          <div
            className="card"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <h3 className="card-title">Our Mission</h3>
            <p>
              To regulate occupational associations to facilitate and promote consumer protection through improvement in
              professional standards under professional standards schemes.
            </p>
          </div>

          <div
            className="card is-fullwidth"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <h3 className="card-title">Our Mandate</h3>

            <TabbedContent tabs={mandateTabs} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
